/* THIS FILE WAS AUTO-GENERATED. DO NOT MODIFY */
/* eslint-disable */
import * as SchemaTypes from '../../../../types/graph';

import * as Operations from './mutation.graphql';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type UpdateUserAttributesMutationVariables = SchemaTypes.Exact<{
  input: SchemaTypes.UpdateUserAttributesMutationInput;
}>;


export type UpdateUserAttributesMutation = { __typename?: 'Mutation', customers: { __typename?: 'CustomersMutation', update_user_attributes: { __typename?: 'Customer', id: string, userAttributes: string } | null } };


export function useUpdateUserAttributesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserAttributesMutation, UpdateUserAttributesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserAttributesMutation, UpdateUserAttributesMutationVariables>(Operations.UpdateUserAttributes, options);
      }
export type UpdateUserAttributesMutationHookResult = ReturnType<typeof useUpdateUserAttributesMutation>;